import { apiClient } from "@/shared/api/client";
import type {
  Applicant,
  ApplicantList,
  Application,
  MyApplication,
  ShortlistStatus,
} from "@/features/applications/types";

export async function applyToShift(shiftId: string): Promise<Application> {
  const { data } = await apiClient.post<Application>(`/shifts/${shiftId}/apply`);
  return data;
}

export async function withdrawApplication(applicationId: string): Promise<Application> {
  const { data } = await apiClient.delete<Application>(`/applications/${applicationId}`);
  return data;
}

export async function listMyApplications(): Promise<MyApplication[]> {
  const { data } = await apiClient.get<MyApplication[]>("/applications/mine");
  return data;
}

export async function getMyApplicationForShift(shiftId: string): Promise<Application | null> {
  const { data } = await apiClient.get<Application | null>(`/shifts/${shiftId}/my-application`);
  return data;
}

export async function listApplicants(shiftId: string): Promise<Applicant[]> {
  const { data } = await apiClient.get<ApplicantList>(`/shifts/${shiftId}/applicants`);
  return data.applicants;
}

export async function confirmWorker(shiftId: string, applicationId: string): Promise<Application> {
  const { data } = await apiClient.post<Application>(
    `/shifts/${shiftId}/applications/${applicationId}/confirm`,
  );
  return data;
}

export async function setApplicantInterest(
  shiftId: string,
  applicationId: string,
  interest: ShortlistStatus,
): Promise<Application> {
  const { data } = await apiClient.patch<Application>(
    `/shifts/${shiftId}/applications/${applicationId}/interest`,
    { interest },
  );
  return data;
}
